module.exports = __webpack_public_path__ + "img/login.6dd902ea.png";